// PauseState{kind,pausedPartCount,activePartCount} -> render-ready label (RN19/RN19.1, D2).
//
// NOT_PAUSED gets no key at all — RN19 says the panel makes NO mention of pausing an order that
// is not paused, rather than showing a "not paused" badge. The counters are only read for
// PARTIALLY_PAUSED, where Sun guarantees them present (plan §1.4).
export const pauseStateLabel = (header) => {
  const source = header || {}

  switch (source.pauseState) {
    case 'PAUSED':
      return { key: 'Paused' }
    case 'PARTIALLY_PAUSED':
      return {
        key: 'Partially paused: {{paused}} of {{active}} parts',
        values: { paused: source.pausedPartCount, active: source.activePartCount }
      }
    case 'UNKNOWN':
      return { key: 'Pause status not available' }
    default:
      return { key: '' }
  }
}
